/* unplugin-vue-components disabled */import { render } from "./orderTel.vue?vue&type=template&id=7a65b336&scoped=true"
import script from "./orderTel.vue?vue&type=script&lang=js"
export * from "./orderTel.vue?vue&type=script&lang=js"

import "./orderTel.vue?vue&type=style&index=0&id=7a65b336&scoped=true&lang=less"
import "./orderTel.vue?vue&type=style&index=1&id=7a65b336&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a65b336"]])

export default __exports__